module.exports = __webpack_public_path__ + "img/banner-deskto 3.08dbf501.png";